import {
  format,
  parseISO,
  isValid,
} from 'date-fns';

const DATE_FORMATS = {
  DISPLAY: 'dd/MM/yyyy',
};

export const formatDate = (
  date,
  formatStr = DATE_FORMATS.DISPLAY
) => {
  if (!date) return '';

  try {
    const dateObj =
      typeof date === 'string'
        ? parseISO(date)
        : new Date(date);

    if (!isValid(dateObj)) return '';

    return format(dateObj, formatStr);
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};

export const formatDatePickerDefaultValue = (dateValue) => {
  if (!dateValue) return '';

  if (typeof dateValue === 'string') {
    const ymdMatch = dateValue.match(
      /^(\d{4})[/-](\d{1,2})[/-](\d{1,2})/
    );

    if (ymdMatch) {
      const [, year, month, day] = ymdMatch;

      return `${day.padStart(2, '0')}/${month.padStart(
        2,
        '0'
      )}/${year}`;
    }
  }

  return formatDate(dateValue, DATE_FORMATS.DISPLAY);
};

export const parseDate = (
  dateString,
  formatStr = DATE_FORMATS.DISPLAY
) => {
  if (!dateString) return null;

  try {
    if (formatStr.includes('dd/MM/yyyy')) {
      const parts = dateString.split(/[\s/:]/);

      if (parts.length >= 3) {
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);
        const hour =
          parts.length > 3 ? parseInt(parts[3], 10) : 0;
        const minute =
          parts.length > 4 ? parseInt(parts[4], 10) : 0;
        const second =
          parts.length > 5 ? parseInt(parts[5], 10) : 0;

        return new Date(
          year,
          month,
          day,
          hour,
          minute,
          second
        );
      }
    }

    return parseISO(dateString);
  } catch (error) {
    console.error('Error parsing date:', error);
    return null;
  }
};

export const isValidDate = (date) => {
  if (!date) return false;

  const dateObj =
    typeof date === 'string'
      ? parseISO(date)
      : new Date(date);

  return isValid(dateObj);
};
